module.exports = __webpack_public_path__ + "static/media/pink_green2.cf78c8c7.jpg";